import { render, staticRenderFns } from "./firstStep.vue?vue&type=template&id=0c9836d4"
import script from "./firstStep.vue?vue&type=script&lang=ts"
export * from "./firstStep.vue?vue&type=script&lang=ts"
import style0 from "./firstStep.vue?vue&type=style&index=0&id=0c9836d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports